
export const ROOT_ROUTE = '/';
export const GO_BACK_PREFIX = 'previousLink';
export const PREV_LINK_STORE = 'default';
